import { render, staticRenderFns } from "./PaymentPoynt.vue?vue&type=template&id=97a684a0&"
import script from "./PaymentPoynt.vue?vue&type=script&lang=js&"
export * from "./PaymentPoynt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports